import RotateErrorIcon from '@/common/assets/icons/rotateErrorIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import {
  cameraRotateModalProps,
  cameraRotateProps,
} from '@/common/components/camera/components/modals/cameraRotateModal/cameraRotateModal.type';
import React from 'react';
import { Box } from 'styled-system/jsx';
const StopCapturingModal: React.FC<cameraRotateProps> = ({ onClose }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <RotateErrorIcon />
      <Typography color="black-1" textStyle="b1" ml="auto">
        فرایند متوقف شد!
      </Typography>
      <Typography color="black-1" textStyle="b2">
        متأسفانه به‌دلیل چرخش صفحه، فرایند عکس برداری متوقف شد. برای جلوگیری از
        این مشکل، لطفاً چرخش خودکار (Auto Rotate) را غیرفعال کنید و دوباره تلاش
        کنید.
      </Typography>
      <Button onClick={onClose} fullWidth color="primary">
        متوجه شدم
      </Button>
    </Box>
  );
};

export default ({ open, onClose }: cameraRotateModalProps) => {
  return (
    <MainModal closeModal={onClose} open={open}>
      <StopCapturingModal onClose={onClose} />
    </MainModal>
  );
};
